import React from "react";
import { Link, useParams } from "react-router-dom";

import PageHeader from "components/PageHeader";
import ResignationDetailPanel from "../components/ResignationDetailPanel";

/** Deep-link target (employee profile, notifications). Same panel the list
 *  opens in its drawer, so the two can never drift apart. */
const ResignationDetail = () => {
  const { id } = useParams();
  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader
          title="Resignation request"
          actions={
            <Link to="/resignations" className="btn btn-outline-primary btn-sm">
              <i className="las la-arrow-left me-1" aria-hidden="true" /> All resignations
            </Link>
          }
        />
        <div className="card" style={{ borderRadius: 14 }}>
          <div className="card-body p-4">
            <ResignationDetailPanel key={id} id={id} layout="split" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResignationDetail;
